export default function SectionTitle({ eyebrow, title, description, align = "left", light = false }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14`}
      data-testid="section-title"
    >
      {eyebrow && (
        <div className={`text-xs uppercase tracking-[0.28em] mb-4 ${light ? "text-brand-bone/60" : "text-brand-sage"}`}>
          {eyebrow}
        </div>
      )}
      <h2
        className={`font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] ${
          light ? "text-brand-bone" : "text-brand-ink"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-brand-bone/70" : "text-brand-muted"}`}>
          {description}
        </p>
      )}
    </div>
  );
}
